<template>
  <div class="home">
    <div class="banner_home">
      <swiper class="banner_swiper" :options="bannerOption">
        <swiper-slide v-for="item in bannerList" :key="item.id">
          <img :src="item.imgUrl" alt="" style="width: 100%;max-height:350px " />
        </swiper-slide>
        <div class="banner_btn btn_left button-prev" slot="button-prev">
          <i class="el-icon-arrow-left"></i>
        </div>
        <div class="banner_btn btn_right button-next" slot="button-next">
          <i class="el-icon-arrow-right"></i>
        </div>
      </swiper>
      <div class="banner-home-pagination"></div>
      <!-- <img
        v-if="$store.state.user.banner.banner1"
        style="width: 100%"
        :src="$store.state.user.banner.banner1"
        alt="banner"
      /> -->
    </div>
    <div class="synop">
      <div class="inner" style="position: relative">
        <ul class="user_list">
          <li class="user_type" v-for="(item,index) in userList" :key="index">
            <div class="img_box">
              <img :src="item.icon" :alt="item.type">
            </div>
            <p>{{ item.type }}</p>
          </li>
        </ul>
        <p style="font-size: 24px"> {{siteMess.siteName}}</p>
        <div class="synop_content">
          <div data-wow-delay=".5s" class="wow fadeInLeft left">
            <p>
              {{siteMess.introduction}}
            </p>
            <ul class="synop_footer">
              <li>
                <!-- <img src="~@/assets/images/synop/1.png" alt="" /> -->
                <span class="synop_txt">
                  <span class="num">{{ synoNums ? synoNums.courseCount : 0 }}</span>
                  <span class="txt">课程数量</span>
                </span>
              </li>
              <li>
                <!-- <img src="~@/assets/images/synop/2.png" alt="" /> -->
                <span class="synop_txt">
                  <span class="num">{{ synoNums ? synoNums.materialCount : 0 }}</span>
                  <span class="txt">资源数量</span>
                </span>
              </li>
              <li>
                <!-- <img src="~@/assets/images/synop/3.png" alt="" /> -->
                <span class="synop_txt">
                  <span class="num">{{ synoNums ? synoNums.studentCount : 0 }}</span>
                  <span class="txt">用户数量</span>
                </span>
              </li>
            </ul>
          </div>
          <div data-wow-delay="1s" class="wow fadeInRight right">
            <video
              controls
              :src="siteMess.videoFile"
            ></video>
          </div>
        </div>
      </div>
    </div>
    <div class="industry_trends">
      <div class="inner">
        <sub-title
          data-wow-delay=".3s"
          class="wow flipInX"
          rbtn="更多>>"
          :img="require('@/assets/images/usertype/baiti_hangye.png')"
          @setRightClick="handleMoreData(1)" />
        <div class="homenotice">
          <div data-wow-delay=".5s" class="wow fadeInLeft left item">
            <div
              v-if="noticeList.length > 0"
              class="left_inner"
              :style="{
                backgroundImage: `url('${noticeList[noticeActive].noticePic}')`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                backgroundSize: 'cover',
              }"
              @click="
                getNotice(
                  noticeList[noticeActive].noticeType,
                  noticeList[noticeActive].noticeId
                )
              "
            >
              <div class="content">
                <div class="footer">
                  <h4 class="title">{{ noticeList[noticeActive].noticeTitle }}</h4>
                </div>
              </div>
            </div>
          </div>
          <div data-wow-delay=".5s" class="wow fadeInRight right item">
            <div class="news_list" v-if="noticeList.length > 0">
              <template v-for="(item, index) in noticeList">
                <div
                  :class="['news_item', noticeActive == index ? 'notice_active' : '']"
                  :key="item.noticeId"
                  @click="getNotice(item.noticeType, item.noticeId)"
                  @mouseover="noticeMouseover(index)"
                  @mouseout="noticeMouseout"
                >
                  <div class="title ellipsis">
                    <i class="el-icon-back"></i>{{ item.noticeTitle }}
                  </div>
                  <div
                    class="time"
                    v-if="item.updateTime == null || item.updateTime == ''"
                  >
                    {{ item.createTime.split(" ")[0] }}
                  </div>
                  <div v-else class="time">{{ item.updateTime.split(" ")[0] }}</div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="rmkc">
      <div class="inner">
        <sub-title
          data-wow-delay=".3s"
          class="wow flipInX"
          @setRightClick="handleMoreData(2)"
          :img="require('@/assets/images/usertype/biaoti_kecheng.png')"
          rbtn="更多>>"
        />
        <div data-wow-delay=".5s" class="wow fadeInUp course_list">
          <new-cursordetail
            class="cursor_item"
            v-for="(item, index) in courseVos"
            @setHandleDetail="getHandleDetailCharge"
            @setEqual="getEqual"
            :cursorDetail="item"
            :key="index"
            :d-height="dHeight"
          />
        </div>
      </div>
    </div>
    <div class="case" v-if="false">
      <div class="inner">
        <sub-title
          data-wow-delay=".3s"
          class="wow flipInX"
          @setRightClick="handleMoreData(3)"
          :img="require('@/assets/images/usertype/biaoti_ziyuan.png')"
          rbtn="更多>>" />
      </div>
      <div data-wow-delay=".5s" class="wow fadeInUp case_content">
        <div class="inner">
          <swiper class="banner_swiper" :options="caseOption">
            <swiper-slide v-for="item in caseList" :key="item.id" style="cursor: pointer">
              <!-- <img style="width:100%;" :src="item.bannerUrl" alt=""> -->
              <el-image
                style="width: 100%; height: 160px"
                :src="item.bannerUrl"
                fit="cover"
                @click="specialRouter(item)"
              ></el-image>
              <p class="case_title ellipsis">{{ item.name }}</p>
            </swiper-slide>
          </swiper>
          <div class="banner_btn btn_left case-prev" slot="button-prev">
            <i class="el-icon-arrow-left"></i>
          </div>
          <div class="banner_btn btn_right case-next" slot="button-next">
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="resource_hot">
      <div class="inner">
        <sub-title
          data-wow-delay=".3s"
          class="wow flipInX sub_title"
          @setRightClick="handleMoreData(6)"
          :img="require('@/assets/images/usertype/biaoti_ziyuan.png')"
          rbtn="更多>>" />
        <div data-wow-delay=".5s" class="wow fadeInUp">
          <div class="emptyall" v-if="metailList == null">
            <el-empty description="资源努力加载中..."></el-empty>
          </div>
          <div class="emptyall" v-else-if="metailList.length == 0">
            <el-empty description="暂无资源"></el-empty>
          </div>
          <div v-else>
            <metail-item :metailList="metailList"></metail-item>
          </div>
        </div>
      </div>
    </div>
    <div class="ele_style">
      <div class="inner">
        <sub-title
          data-wow-delay=".3s"
          class="wow flipInX sub_title"
          @setRightClick="handleMoreData(6)"
          :img="require('@/assets/images/usertype/biaoti_zhuanjia.png')"
        />
      </div>
      <div class="ele_style_content wow fadeInUp" data-wow-delay=".5s" >
        <div class="inner">
          <swiper class="banner_swiper" :options="eleStyleOption" v-if="eleStyleList.length>0">
            <swiper-slide v-for="item in eleStyleList" :key="item.id" style="cursor: pointer">
              <div class="swiper_item">
                <el-image
                  style="width: 100%; height: 487px;display: block;"
                  :src="item.pic"
                  fit="cover"
                  @click="specialRouter(item)"
                ></el-image>
                <div class="ele_style_text">
                  <el-scrollbar style="height:  480px;"  tag="section">
                    <div class="text_inner">
                      <p class="teacher">{{ item.name }}</p>
                      <p class="syno">{{ item.introduction }}</p>
                    </div>
                  </el-scrollbar>
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <div class="banner_btn btn_left elestyle-prev" slot="button-prev">
            <i class="el-icon-arrow-left"></i>
          </div>
          <div class="banner_btn btn_right elestyle-next" slot="button-next">
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="school_ent">
      <div class="inner">
        <sub-title
          data-wow-delay=".3s"
          class="wow flipInX sub_title"
          @setRightClick="handleMoreData(6)"
          :img="require('@/assets/images/usertype/biaoti_xiaoqi.png')"
        />
      </div>
      <div class="school_ent_content wow fadeInUp" data-wow-delay=".5s">
        <div class="inner">
          <swiper class="banner_swiper" :options="schoolOption">
            <swiper-slide class="swiper_item" v-for="item in schoolList" :key="item.id" style="cursor: pointer" v-if="schoolList.length>0">
              <div @click="handleProview(item)">
                <div class="school_img_box">
                  <el-image
                    style="width: 100%; height: 314px;display: block;"
                    :src="item.cover"
                    fit="cover"
                  ></el-image>
<!--                  <div class="model" v-if="item.fileUrl.slice(item.fileUrl.lastIndexOf('.') + 1)=='mp4'"></div>-->
                </div>
                <div class="school_ent_text">
                  <p class="spact">{{ item.schoolName }}</p>
                  <p class="syno">{{ item.schoolIntroduction }}</p>
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <div class="banner_btn btn_left school-prev" slot="button-prev">
            <i class="el-icon-arrow-left"></i>
          </div>
          <div class="banner_btn btn_right school-next" slot="button-next">
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="share" v-if="false">
      <div class="inner wow fadeInUp" data-wow-delay=".5s">
          <div class="inner">
            <sub-title
              :type="2"
              name="主办院校"
              data-wow-delay=".3s"
              class="wow flipInX sub_title"
            />
          </div>
        <div class="jingmaologo">
          <div class="item_school" v-for="item in zhubanList" :key="item.id" @click="handleSchoolPath(item)">
            {{item.schoolName}}
          </div>
        </div>
        <div class="inner">
          <sub-title
            :type="2"
            :is-show="true"
            name="参建院校"
            data-wow-delay=".3s"
            class="wow flipInX sub_title"
          />
        </div>
        <div class="outher">
          <div class="item_school" v-for="item in gongjianList" :key="item.id" @click="handleSchoolPath(item)">
            {{item.schoolName}}
          </div>

        </div>
      </div>
    </div>
    <!-- 视频预览 -->
    <el-dialog :visible.sync="dialogVadioSeeVisible" custom-class="vadioSee" width="600px"
        @close="handleVadioSeeClose">
        <d-player ref="vadio" :vadio-url="vadioUrl" />
    </el-dialog>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import { WOW } from "wowjs";
import "wowjs/css/libs/animate.css";
import DPlayer from "@/components/DPlayer"
import CursorList from "@/components/Cursor";
import NewCursordetail from "@/components/NewCursordetail";
import SubTitle from "@/components/SubTitle";
// publicCourse, 公开课接口
import {
  listCourse,
  getTeacherList,
  getWebListCourse,
  pcCount,
  featuredCase,
  expertList,
  cobreedingList,
  partnerList,
  getWebsiteConfigInfo,
  getCarouselList
} from "@/api/home";
import { nocget } from "@/api/notice.js";
import { wordlimit } from "@/utils";
// 素材库列表
import { queryES } from "@/api/library";
import metailItem from "@/components/metailItem/index.vue";

export default {
  name: "Home",
  data() {
    return {
      // banner 轮播图配置
      bannerOption: {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        autoplay: true,
        effect: "fade",
        navigation: {
          nextEl: ".button-next",
          prevEl: ".button-prev",
        },
        pagination: {
          el: ".banner-home-pagination",
          clickable: true,
        },
      },
      bannerList: [

      ],
      userList:[{
        type:'学生用户',
        icon:require('@/assets/images/usertype/xuesheng_renyuan.png')
      },{
        type:'教师用户',
        icon:require('@/assets/images/usertype/jjiaoshi_renyuan.png')
      },{
        type:'企业员工',
        icon:require('@/assets/images/usertype/qiye_renyuan.png')
      },{
        type:'自学人员',
        icon:require('@/assets/images/usertype/zixue_renyuan.png')
      }],
      siteMess:{},
      imgalt: "",
      publicCourses: [],
      courseVos: [],
      loading: false,
      synoNums: null,
      pdfList: [
        {
          img: require("../assets/images/dzpdf1.png"),
          title: "电子商务师",
          id: 1,
          pdfUrl: require("../assets/pdf/dzs1.pdf"),
        },
        {
          img: require("../assets/images/dzpdf2.png"),
          title: "计算机及外部设备装配调试员",
          id: 2,
          pdfUrl: require("../assets/pdf/dzs2.pdf"),
        },
        {
          img: require("../assets/images/dzpdf3.png"),
          title: "计算机网络管理员",
          id: 3,
          pdfUrl: require("../assets/pdf/dzs3.pdf"),
        },
        {
          img: require("../assets/images/dzpdf4.png"),
          title: "健康管理师",
          id: 4,
          pdfUrl: require("../assets/pdf/dzs4.pdf"),
        },
      ],
      dHeight: 0,
      teacherList: [],
      noticeList: [],
      noticeActive: 0,
      noticeTimer: null,
      metailList: null,
      // 特色案例轮播
      caseOption: {
        slidesPerView: 4,
        spaceBetween: 20,
        autoplay: false,
        navigation: {
          nextEl: ".case-next",
          prevEl: ".case-prev",
        },
      },
      caseList: [],
      // 专家风采轮播
      eleStyleOption: {
        slidesPerView: 3,
        spaceBetween: 88,
        autoplay: false,
        navigation: {
          nextEl: ".elestyle-next",
          prevEl: ".elestyle-prev",
        },
      },
      eleStyleList:[],
      // 校企共育
      schoolOption:{
        slidesPerView: 2,
        spaceBetween: 29,
        autoplay: false,
        navigation: {
          nextEl: ".school-next",
          prevEl: ".school-prev",
        },
      },
      schoolList:[],
      zhubanList:[],
      gongjianList:[],
      dialogVadioSeeVisible:false,
      vadioUrl:''
    };
  },
  components: {
    swiper,
    swiperSlide,
    CursorList,
    SubTitle,
    NewCursordetail,
    metailItem,
    DPlayer
  },
  created() {
    this.getCarouselList()
    this.getWebsiteConfigInfo()
    this.$store.commit("user/SET_TABINDEX", 1010);
    this.pcCount();
    this.getTeacherList();
    this.getNoticeList();
    // this.publicCourse({
    //   pageNum: 1,
    //   pageSize: 3,
    // });
    this.getWebListCourse({
      pageNum: 1,
      pageSize: 8,
      isRecommend: 1,
    });
    this.featuredCase();
    this.filelistall();
    this.expertList();
    this.cobreedingList();
    this.partnerList({
      isHide:0,
      type:'0'
    });
    this.partnerList({
      isHide:0,
      type:'1'
    });
  },
  mounted() {
    new WOW().init();
  },
  destroyed() {
    clearInterval(this.noticeTimer);
  },
  methods: {
    //获取网站基础信息
    getWebsiteConfigInfo(){
      getWebsiteConfigInfo().then(res => {
        console.log(res.data)
        this.siteMess=res.data
      });
    },
    getCarouselList(){
      getCarouselList({
        pageNum:1,
        pageSize:10,
      }).then(res => {
        this.bannerList=res.rows
      });
    },
    wordlimit,
    // 获取课程数量
    pcCount() {
      pcCount().then((res) => {
        this.synoNums = res;
      });
    },
    listCourseBox() {
      this.loading = true;
      listCourse()
        .then((res) => {
          this.loading = false;
          if (res.code == 200) {
            this.courseVos = res.data.courseVos.map((v) => {
              return {
                ...v,
                courses: v.courses.map((iv) => {
                  return {
                    cover: iv.cover,
                    createId: iv.createId,
                    createTime: iv.createTime,
                    description: iv.description,
                    id: iv.id,
                    teacherName: iv.teacherName,
                    title: iv.title,
                    updateId: iv.updateId,
                    updateTime: iv.updateTime,
                    classHours:
                      iv.classHours / 60 / 45 == 0
                        ? "0"
                        : (iv.classHours / 60 / 45).toFixed(2),
                  };
                }),
              };
            });
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    getTeacherList() {
      getTeacherList({
        pageNum: 1,
        pageSize: 3,
      }).then((res) => {
        if (res.code == 200) {
          this.teacherList = res.rows;
        }
      });
    },
    getNoticeList() {
      nocget({
        pageNum: 1,
        pageSize: 6,
      }).then((res) => {
        if (res.code == 200) {
          this.noticeList = res.rows;
          setTimeout(() => this.setNoticeSwiper(), 1000);
        }
      });
    },
    setNoticeSwiper() {
      clearInterval(this.noticeTimer);
      this.noticeTimer = setInterval(() => {
        this.noticeActive = (this.noticeActive + 1) % 6;
      }, 4000);
    },
    // 跳转资讯详情
    getNotice(title, id) {
      let rourl = this.$router.resolve({
        name: "NoticeDetails",
        params: { name: "natice-detail", title, id },
      });
      window.open(rourl.href);
    },
    noticeMouseover(i) {
      clearInterval(this.noticeTimer);
      this.noticeActive = i;
    },
    noticeMouseout() {
      this.setNoticeSwiper();
    },
    getWebListCourse(params) {
      getWebListCourse(params)
        .then((res) => {
          if (res.code == 200) {
            this.courseVos = res.rows.map((v) => {
              return {
                cover: v.cover,
                createId: v.createId,
                createTime: v.createTime,
                description: v.description,
                id: v.id,
                teacherName: v.teacherName,
                title: v.title,
                updateId: v.updateId,
                updateTime: v.updateTime,
                classHours: v.classHours,
                chapterCount: v.chapterCount,
                professionId: v.professionId,
              };
            });
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 特色案例列表
    featuredCase() {
      featuredCase().then((res) => {
        console.log(res.data, "data");
        this.caseList = res.data;
      });
    },
    getEqual(h) {
      this.dHeight = this.dHeight < h ? h : this.dHeight;
    },
    getHandleDetail(data) {
      let rourl = this.$router.resolve({ path: "/openclass", query: { id: data.id } });
      window.open(rourl.href);
    },
    getHandleDetailCharge(data) {
      let rourl = this.$router.resolve({
        path: "/coursedetails",
        query: { id: data.id, professionId: data.professionId },
      });
      window.open(rourl.href);
    },
    // 更多
    handleMoreData(index) {
      var arr = [
        "/notice",
        "/course-center",
        "/navtab?navId=49",
        "/course-center",
        "/teacher-style",
        "/library",
      ];
      this.$router.push(arr[index - 1]);
    },
    // 技能标准
    handleStabdard(item) {
      window.open(item.pdfUrl);
    },

    // 素材资源列表
    filelistall() {
      let datas = {
        keywords: "",
        mediaType: "",
        sample: "",
        sortName: "",
        status: 2,
      };
      queryES(datas, { size: 8, page: 1 })
        .then((res) => {
          if (res.code == 200) {
            this.metailList = res.rows;
          }
        })
        .catch((err) => {});
    },
    //特色创新按钮
    specialRouter(item) {
      this.$router.push({
        path: "/navtab",
        query: {
          navId: 49,
          homeselId: item.id,
        },
      });
    },
    expertList(){
      expertList().then(res=>{
        console.log(res)
        this.eleStyleList = res.rows
      })
    },
    cobreedingList(){
      cobreedingList().then(res=>{
        console.log(res)
        this.schoolList = res.rows
      })
    },
    partnerList(params){
      partnerList(params).then(res=>{
        if(params.type==0){
          this.zhubanList = res.rows
        }else if(params.type==1){
          this.gongjianList = res.rows
          console.log(this.gongjianList,'============gongjianList');
        }
      })
    },
    handleSchoolPath(item){
      const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
      const isUrl = reg.test(item.schoolLink)
      if(isUrl){
        window.open(item.schoolLink,'_bank')
      }else{
        this.$message({
          message: '暂无链接',
          type: 'error',
          iconClass: ' ', // 这个会覆盖图标类名，为了实现去掉图标的操作
          customClass: 'el-message--error', // 这个是由于上面设置了iconClass会覆盖掉type，所以需要再设置
        });

      }
    },
    handleVadioSeeClose() {
      this.$refs.vadio.playered.pause();
    },
    handleProview(item){
      // const emp = item.fileUrl.slice(item.fileUrl.lastIndexOf('.') + 1)
      // if(emp=='mp4'){
      //   this.dialogVadioSeeVisible = true
      //   this.vadioUrl = item.fileUrl
      //   this.$nextTick(() => {
      //       setTimeout(() => {
      //           this.$refs.vadio.playered.switchVideo({ url: item.fileUrl })
      //       }, 200);
      //   });
      // }
      this.$router.push({path:'/schools-profile',query:{id:item.id}})
    }
  },
};
</script>
<style lang="scss" scoped>
@font-face {
  font-family: 'WebHouheiFont';
  src: url('~@/assets/fount/houhei.ttf');
}
.home {
  background: #fff;
  min-height: 1000px;
}
.banner_home {
  min-height: 350px;
  position: relative;
  .banner-home-pagination {
    position: absolute;
    bottom: 95px;
    z-index: 8;
    left: 50%;
    transform: translateX(-50%);

    // right: 20px;
    ::v-deep .swiper-pagination-bullet {
      margin-left: 10px;
      width: 13px;
      height: 13px;
      border: 1px solid #FFFFFF;
      background: transparent;
      opacity: 1;
      transition: all .2s;
      &.swiper-pagination-bullet-active {
        width: 33px;
        height: 13px;
        background: #D9AF71;
        border-radius: 7px;
        border-color: #D9AF71;
      }
      &:first-of-type {
        margin-left: 0px;
      }
    }
  }
}
.synop {
  // background: url("~@/assets/images/async.png") no-repeat top center;
  // background-size: cover;
  padding-top: 53px;
  padding-bottom: 40px;
  // margin-top: -129px;
  position: relative;
  z-index: 2;
  .user_list{
    display: flex;
    align-items: center;
    justify-content: space-around;
    text-align: center;
    margin-bottom: 64px;
    .img_box{
      height: 110px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .synop_content {
    padding-top: 15px;
    display: flex;
    .left {
      flex: 1;
      padding-right: 41px;
      p {
        font-size: 16px;
        padding-top: 32px;
        padding-bottom: 41px;
        line-height: 1.8;
      }
      .synop_footer {
        display: flex;
        text-align: center;
        li {
          display: flex;
          flex: 1;
          align-items: center;
          .num {
            font-size: 40px;
            font-family: Bertha;
            font-weight: 400;
            color: #1D4434;
            font-family: WebHouheiFont;
          }
          .txt {
            font-size: 14px;
            color: #333;
          }
        }
      }
      .synop_txt {
        margin-left: 10px;
        span {
          display: block;
        }
      }
    }
    .right {
      width: 544px;
      height: 315px;
      border-radius: 8px;
      border: 7px solid #D5B069;
      background-color: #D5B069;
      video {
        width: 100%;
        height: 100%;
        border-radius: 6px;
        background-color: #1D4434;
      }
    }
  }
}
.scure_content {
  padding-top: 100px;
  background: #fff;
  padding-bottom: 100px;
}
.industry_trends {
  // background: url("~@/assets/images/notice.png") no-repeat center center;
  // background-size: cover;
  padding-bottom: 29px;
  .homenotice {
    display: flex;
    padding-top: 34px;
    // padding-bottom: 100px;
    .item {
      height: 315px;
    }
    .left {
      width: 45%;
      padding-right: 20px;
      .left_inner {
        height: 100%;
        position: relative;
        cursor: pointer;
        border-radius: 8px;
        overflow: hidden;
        &::after {
          content: " ";
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 40%;
          background-image: linear-gradient(#f7881900, #114D34);
        }
        .content {
          position: relative;
          z-index: 5;
          height: 100%;
          color: #fff;
          display: flex;
          align-items: flex-end;
        }
        .footer {
          color: #fff;
          padding: 0 24px;
          line-height: 1.3;
          font-weight: 500;
          .title {
            font-size: 24px;
            margin-bottom: 21px;
          }
        }
      }
    }
    .right {
      padding: 0 23px;
      width: 55%;
      .news_item {
        display: flex;
        justify-content: space-between;
        position: relative;
        font-size: 18px;
        padding: 17px 0;
        line-height: 1;
        cursor: pointer;
        padding-left: 57px;
        position: relative;
        transition: all 0.3s;
        i {
          transition: all 0.3s;
          position: absolute;
          top: 50%;
          left: 0px;
          width: 40px;
          height: 40px;
          background-color: #1D4434;
          border-radius: 50%;
          transform: translateY(-50%);
          color: #fff;
          font-size: 18px;
          text-align: center;
          line-height: 40px;
          opacity: 0;
        }
        &.notice_active {
          color: #1D4434;
          font-weight: bold;
          padding-left: 25px;
          i {
            left: -30px;
            opacity: 1;
          }
        }
        .time {
          width: 95px;
          text-align: right;
          color: #ccc;
          font-size: 14px;
          font-weight: 200;
        }
        .title {
          flex: 1;
        }
      }
    }
  }
}

.rmkc {
  // background: url("~@/assets/images/rmkc.png") no-repeat center center;
  // background-size: cover;
  // padding-top: 76px;
  // padding-bottom: 40px;
  // overflow: hidden;
  .sub_title {
    margin-bottom: 37px;
  }
}
.case {
  background: url("~@/assets/images/case.png") no-repeat center center;
  background-size: cover;
  padding-top: 76px;
  padding-bottom: 87px;

  .case_content {
    position: relative;
  }
  .banner_swiper {
    margin-top: 37px;
  }
  .case_title {
    font-size: 18px;
    margin-top: 15px;
  }

}
.resource_hot {
  // background: url("~@/assets/images/resource_hot.png") no-repeat center center;
  // background-size: cover;
  // padding-top: 76px;
  // padding-bottom: 60px;
}
.course_list {
  display: flex;
  flex-wrap: wrap;
  margin-left: -7px;
  margin-right: -7px;
  .cursor_item {
    width: 25%;
    margin-bottom: 40px;
    ::v-deep .cursor_inner {
      background: #fff;
    }
  }
}
.standard_list {
  display: flex;
  margin-left: -34px;
  margin-right: -34px;
  .stabdard_item {
    width: 25%;
    padding: 0 33px;
    .item_inner {
      padding: 15px 20px;
      background: #fff;
      box-shadow: 0px 3px 7px 0px rgb(0 0 0 / 10%);
      cursor: pointer;
      p {
        line-height: 1;
        margin-top: 20px;
        padding-bottom: 16px;
      }
    }
  }
}
.teacher_list {
  margin-left: -30px;
  margin-right: -30px;
  display: flex;
  flex-wrap: wrap;
  .teacher_item {
    width: 33.33%;
    padding: 0 30px;
    color: #333333;
    margin-bottom: 100px;

    .item_inner {
      border: 1px solid #b2b2b2;
      background: #fff;
      padding: 50px 0 0;
    }
    .teacher_info {
      padding: 0 31px;
      text-align: center;
    }
    .name {
      font-size: 26px;
      line-height: 1;
      font-weight: 800;
      margin: 39px 0 34px;
    }
    .synopsis {
      font-size: 15px;
      font-weight: 500;
      line-height: 1.5;
      height: 110px;
      overflow: hidden;
    }
  }
}
.ele_style{
  // background: url("~@/assets/images/zhuanjiafengcai_bg.png") no-repeat center center;
  // background-size: cover;
  // padding-top: 88px;
  // padding-bottom: 73px;
  .sub_title{
    margin-bottom: 55px;
  }
  .ele_style_content{
    .inner{
      position: relative;
    }
    .swiper_item{
      position: relative;
      .ele_style_text{
        position: absolute;
        bottom: 0;
        left:0;
        width: 100%;
        height: 150px;
        background-color: #fff;
        padding: 20px 37px;
        color: #174C36;
        transition-property:height,background-color,color;
        transition-duration:.3s;
        overflow: hidden;
        ::v-deep .el-scrollbar__wrap{
          overflow-x: hidden;
        }
        .teacher{
          font-weight: bold;
          font-size: 16px;
          margin-bottom: 15px;
          text-align: center;
        }
        .syno{
          height: 74px;
          font-size: 14px;
          overflow: hidden;
          line-height: 1.9;
          word-break: break-all;
          text-overflow: ellipsis;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }

      }
      &:hover{
        .ele_style_text{
          height: 100%;
          background-color: rgba(0, 0, 0, .7);
          color: #fff;
          padding: 10px 10PX;
          display: flex;
          align-items: center;
          justify-content: center;
          .text_inner{
            padding:0 45px;
            padding-top: 40px;
          }
          &::after{
            content: ' ';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 4px;
            background-color: #1d4434;
          }
          .teacher{
            margin-bottom: 41px;
          }
          .syno{
            font-size: 16px;
            height: auto;
            overflow: inherit;
            display: block;
          }
        }
      }
    }
    .banner_btn{
      position: absolute;
      top: -63px;
      right: 20px;
      left: auto!important;
      border-color: #355749;
      color: #355749;
      height: 26px;
      width: 26px;
      font-size: 14px;

      &:hover{
        color: #fff;
      }
      &.elestyle-prev{
        right: 80px;
      }
    }
    .elestyle-next{

    }
  }

}
.school_ent{
  // background: url("~@/assets/images/hezuoxiaoyuan_bg.png") no-repeat center center;
  // background-size: cover;
  padding-top: 93px;
  padding-bottom: 109px;
  .sub_title{
    margin-bottom: 45px;
  }
  .school_ent_content{
    position: relative;
    .school_img_box{
      position: relative;
      .model{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, .7);
        &::after{
          content: ' ';
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%,-50%);
          height: 38px;
          width: 38px;
          background: url('~@/assets/images/bofang_icon.png');
          margin: auto;
        }
      }
    }
    .school_ent_text{
      .spact{
        padding: 30px 0;
        font-size: 18px;
        font-weight: bold;
        line-height: 1;
        text-align: center;
      }
      .syno{
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        line-height: 1.8;
        word-break: break-all;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        height: 75px;
        padding: 0 48px;
      }
    }
    .swiper_item:hover{
      color: #174C36;
    }
  }

}
.share{
  padding-top: 80px;
  padding-bottom: 60px;
  background: url("~@/assets/images/zhuban_bg.png") no-repeat center center;
  background-size: cover;
  .share_title{
    display: flex;
    justify-content: flex-start;
    height: 30px;
    overflow: hidden;
    .title_logo{
      width: 194px;
      height: 26px;
      background: url("~@/assets/images/xueqianjiaoyuzhuanyeziyuanku.png") no-repeat center center;
      margin-top: 2px;
    }
    .title_line{
      width: 25px;
      height: 2px;
      margin: 14px 10px;
      background-color: #1d4434
    }
    .title_text{
      font-size: 24px;
      font-weight: 400;
      line-height: 30px;
      color: #1d4434;
    }
  }
  .jingmaologo{
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 50px;
    .item_school{
      cursor: pointer;
      font-size: 18px;
      color: #333333;
      margin: 0px 30px;
      margin-top: 50px;
      &:hover{
        cursor: pointer;
        color: #1d4434;
      }
    }
  }
  .outher{
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 10px;
    .item_school{
      font-size: 16px;
      color: #333333;
      margin: 0px 30px;
      margin-top: 50px;
      &:hover{
        cursor: pointer;
        color: #1d4434;
      }
    }

  }
}
.banner_btn {
    cursor: pointer;
    position: absolute;
    top: 50%;
    z-index: 3;
    font-size: 30px;
    height: 51px;
    width: 51px;
    border: 2px solid #fff;
    border-radius: 50%;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    transform: translateY(-50%);
    transition: all .3s;
    &.btn_left {
      left: 220px;
    }
    &.btn_right {
      right: 220px;
    }
    &:hover{
      background-color: #1D4434;
      color: #fff;
    }
  }
</style>
<style lang="scss">
.vadioSee {
    .el-dialog__header {
        padding: 0;
    }

    .el-dialog__body {
        padding: 0;
    }

    .el-dialog__close {
        color: #fff;
        position: relative;
        z-index: 2;
        font-size: 28px;
    }
}
</style>
